import { Virtuoso, VirtuosoHandle } from 'react-virtuoso';
import { PDFDocumentProxy } from 'pdfjs-dist';
import { Page } from './Page';
import { useEffect, useRef } from 'react';
import { useFilePreviewStore } from '@mygpt/app/chat/stores/useFilePreviewStore';

export const PDFPreviewList = ({
  pdf,
  defaultPageIndex,
  fitWidth = false,
}: {
  defaultPageIndex: number;
  pdf: PDFDocumentProxy;
  fitWidth?: boolean;
}) => {
  const { highlightPositions } = useFilePreviewStore();
  const virtuoso = useRef<VirtuosoHandle>(null);
  const pageList = [...Array(pdf.numPages).keys()];

  useEffect(() => {
    console.log('defaultPageIndex', defaultPageIndex, pdf, virtuoso);
    setTimeout(() => {
      if (!virtuoso.current) return;

      virtuoso.current.scrollToIndex({
        index: defaultPageIndex,
        align: 'start',
      });
    }, 1000);
  }, [defaultPageIndex, pdf]);

  return (
    <Virtuoso
      ref={virtuoso}
      style={{ height: '100%' }}
      data={pageList}
      initialTopMostItemIndex={defaultPageIndex}
      increaseViewportBy={200}
      itemContent={(_, pageIndex) => {
        const currentPageHighlightPositions = highlightPositions.find(
          ({ page: pageNumber }) => pageNumber === pageIndex
        );
        return (
          <Page
            currentPage={pageIndex + 1}
            pdf={pdf}
            highlightPositions={currentPageHighlightPositions}
            fitWidth={fitWidth}
          />
        );
      }}
    />
  );
};
